<template>
  <v-form ref="form" v-model="valid" @submit.prevent="save">
    <v-card-text>
      <v-container>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-autocomplete
              label="Jenis Kelas"
              dense
              outlined
              v-model="data.class_type_id"
              :items="listClassType"
              item-text="name"
              item-value="id"
              clearable
              :rules="rules.class_type_id"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" md="6">
            <v-autocomplete
              label="Instruktur Kelas"
              dense
              outlined
              v-model="data.class_instructor_id"
              :items="listClassInstructor"
              item-text="name"
              item-value="id"
              clearable
              :rules="rules.class_instructor_id"
            />
          </v-col>
          <v-col cols="12" md="6">
            <date-picker
              class="mb-6"
              placeholder="Tanggal Kelas"
              valueType="format"
              :format="'YYYY-MM-DD'"
              v-model="data.class_date"
              :rules="rules.class_date"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="data.start_time"
              label="Jam Mulai"
              type="time"
              dense
              outlined
              :rules="rules.start_time"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="data.end_time"
              label="Jam Selesai"
              type="time"
              dense
              outlined
              :rules="rules.end_time"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" md="4">
            <v-text-field
              label="Kuota"
              dense
              outlined
              v-model="data.quota"
              type="number"
              :rules="rules.quota"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" md="6">
            <v-checkbox
              v-model="data.is_instructor_present"
              label="Instruktur Hadir"
              dense
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <v-textarea
              label="Deskripsi"
              dense
              outlined
              v-model="data.description"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn color="success" :loading="loading" @click="save">
        <v-icon small left>mdi-content-save</v-icon>
        Simpan
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  props: {
    id: {
      type: String,
      default: null,
    }

  },
  data() {
    return {
      loading: false,
      valid: true,
      listClassType: [],
      listClassInstructor: [],
      data: {
        class_type_id: null,
        class_instructor_id: null,
        class_date: null,
        start_time: null,
        end_time: null,
        quota: null,
        description: null,
        is_instructor_present: false,
      },
      rules: {
        class_type_id: [(v) => !!v || "Jenis Kelas harus diisi"],
        class_instructor_id: [(v) => !!v || "Instruktur harus diisi"],
        class_date: [(v) => !!v || "Tanggal harus diisi"],
        start_time: [(v) => !!v || "Jam mulai harus diisi"],
        end_time: [(v) => !!v || "Jam selesai harus diisi"],
        quota: [(v) => !!v || "Kuota harus diisi"],
      },
    };
  },
  async mounted() {
    const [classType, classInstructor] = await Promise.all([
      ApiService.get("class-type/list"),
      ApiService.get("class-instructor/list"),
    ]);
    this.listClassType = classType.data;
    this.listClassInstructor = classInstructor.data;
  },
  methods: {
    async getData(id) {
      this.loading = true;
      try {
        const { data } = await ApiService.get("class-schedule?id=" + id);
        this.data = {
          class_type_id: data.class_type_id,
          class_instructor_id: data.class_instructor_id,
          class_date: data.class_date,
          start_time: data.start_time,
          end_time: data.end_time,
          quota: data.quota,
          description: data.description,
          is_instructor_present: data.is_instructor_present || false,
        };
      } catch (e) {
        this.$swal.fire({
          icon: "error",
          title: "Gagal ambil data",
          text: e?.response?.data?.error || "Terjadi kesalahan",
        });
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.$refs.form.validate();
      if (!this.valid) return;

      this.loading = true;
      try {
        const method = this.id ? "update" : "post";
        const url = this.id ? `class-schedule?id=${this.id}` : "class-schedule";

        await ApiService[method](url, this.data);

        this.$emit("success");
      } catch (err) {
        this.$swal.fire({
          icon: "error",
          title: "Gagal menyimpan",
          text: err?.response?.data?.error || "Terjadi kesalahan",
        });
      } finally {
        this.loading = false;
      }
      this.resetForm();
    },
    resetForm() {
      this.data = {
        class_type_id: null,
        class_instructor_id: null,
        class_date: null,
        start_time: null,
        end_time: null,
        is_instructor_present: false,
        quota: 0,
        description: null,
      };
      if (this.$refs.form?.reset) {
        this.$refs.form.reset(); // validasi reset
      }
    },
  },
  watch: {
    id(newVal) {
      if (newVal) {
        this.getData(newVal);
      } else {
        this.resetForm();
      }
    },
  },
};
</script>
